module.exports = __webpack_public_path__ + "Server-CalamariNeedsUpgrade.TentaclePassive.e4e756dbd8dec1b41be0babd627596b8.hashedasset.svg";